<template src="./added-media.html"></template>

<script lang="ts">
import { ACCEPTED_MIME_TYPES, MAX_MEDIA, TYPE_PHOTO } from 'util/media-utils'
import domUtils from 'util/dom-utils'
import MediaSizeMixin from './MediaSizeMixin.vue'
import submissionStore from 'store/submission-store'
import { truncateText } from 'util/text-utils'
import FieldGroup from 'objects/form/FieldGroup.vue'
import MediaThumb from 'objects/media/MediaThumb.vue'
import MediaSubmissionThumb from 'objects/media/MediaSubmissionThumb.vue'


const CAPTION_TRUNCATE_LENGTH = 50 // review form
const SP_CAPTION_TRUNCATE_LENGTH = 35 // share a photo screen
const CAPTION_TRUNCATE_ALLOWANCE = 7

export default {
  data() {
    return {
      media: [],
      submissionStore
    }
  },
  props: {
    errorText: String,
    forReviewForm: Boolean,
    label: String
  },
  emits: ['addPhotos', 'addVideo'],
  components: {
    'tt-field-group': FieldGroup,
    'tt-media-thumb': MediaThumb,
    'tt-media-submission-thumb': MediaSubmissionThumb
  },
  mixins: [MediaSizeMixin],
  computed: {
    addPhotoTxt() {
      return this.$msg(`addedMedia.addPhoto${this.forReviewForm ? '.review' : ''}`)
    },
    addVideoTxt() {
      return this.$msg(`addedMedia.addVideo${this.forReviewForm ? '.review' : ''}`)
    },
    btnDescribedby() {
      return 'tt-add-media-desc' + (this.forReviewForm ? '' : ' tt-share-media-desc')
    },
    hasMaxMedia() {
      return this.media && this.media.length >= MAX_MEDIA
    },
    mediaSize() {
      return 46 // as of now, not customizable, and the same for desktop and mobile
    },
    supportedImageTypes() {
      return ACCEPTED_MIME_TYPES
    }
  },
  methods: {
    addPhotos(e) {
      this.$emit('addPhotos', e.target.files)
    },
    addVideo() {
      this.$emit('addVideo')
    },
    removeMedia(media) {
      // remove from the store as well as the copied decorated version used for this component
      const indexOfItem = this.submissionStore.removeMedia(media)
      this.media.splice(indexOfItem, 1)
      // focus on adding a photo
      domUtils.safeFocusRef(this.$refs, 'addPhotoBtn')
    },
    setupMedia() {
      const media = JSON.parse(JSON.stringify(this.submissionStore.addedMedia))
      const currentNums = {
        photo: 1,
        video: 1
      }
      media.forEach((item) => {
        // add properties used for this component
        const type = item.type ===  TYPE_PHOTO ? 'photo' : 'video'
        const a11yCaptionText = item.text ? `: ${item.text}` : ''
        item.altText = this.$msg(`media.${type}`, [currentNums[type]]) + a11yCaptionText
        item.removeMsg = this.$msg(`media.remove.${type}`, [currentNums[type]]) + a11yCaptionText
        if (item.text) {
          const truncateLength = this.forReviewForm ?
            CAPTION_TRUNCATE_LENGTH : SP_CAPTION_TRUNCATE_LENGTH
          const truncatedText = truncateText(item.text, truncateLength, CAPTION_TRUNCATE_ALLOWANCE)
          item.captionText = truncatedText || item.text
          item.isTruncated = truncatedText ? true : false
        } else {
          item.captionText = this.$msg('addedMedia.noCaption')
        }
        currentNums[type]++
      })
      this.media = media
    },
    triggerAddPhotos() {
      this.$refs.addPhotosInput.click()
    }
  },
  activated() {
    // need to reset in case user canceled the caption submission, came back and tried to upload
    // the same photo.  Because the value is the same the @change event is not fired in this case.
    this.$refs.addPhotosInput.value = ''
    this.setupMedia()
  },
  created() {
    this.setupMedia()
  },
  mounted() {
    // see comment above in activated
    this.$refs.addPhotosInput.value = ''
  }
}
</script>

<style lang="scss" src="./added-media.scss"></style>
